import useBranchPeople from "./useBranchePeople";

export default useBranchPeople;
